export default "__VITE_ASSET__4629878a__"